import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pen",
  "use": "icon-pen-usage",
  "viewBox": "0 0 13 13",
  "content": "<symbol viewBox=\"0 0 13 13\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-pen\">\n<path d=\"M0.125 10.2188V12.8751H2.78125L10.6154 5.04089L7.95917 2.38465L0.125 10.2188ZM12.6696 2.98673C12.9458 2.71048 12.9458 2.26423 12.6696 1.98798L11.0121 0.330479C10.7358 0.0542285 10.2896 0.0542285 10.0133 0.330479L8.71708 1.62673L11.3733 4.28298L12.6696 2.98673Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol